module.exports = __webpack_public_path__ + "img/4bf1224dddde42410a1f93ff46225cbc.svg";